// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-email-readme-tsx": () => import("./../../../src/pages/email-readme.tsx" /* webpackChunkName: "component---src-pages-email-readme-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

